import { useMetaTags } from '../../shared/hooks/useMetaTags';
import { useLanguage } from '../../shared/hooks/useLanguage';
import { PRIVACY_POLICY_CONTENT } from '../../shared/config/constants';
import './LegalPage.css';

/**
 * プライバシーポリシーページコンポーネント
 */
function PrivacyPolicy() {
  const lang = useLanguage();
  const content = PRIVACY_POLICY_CONTENT[lang];

  // メタタグを設定
  useMetaTags({
    title: lang === 'ja' ? 'プライバシーポリシー | ブログ' : 'Privacy Policy | Blog',
    description: lang === 'ja' 
      ? '当サイトのプライバシーポリシーについて説明します。'
      : 'This page explains the privacy policy of this site.',
  });

  const renderContent = (section: typeof content.sections[0]) => {
    const contentArray = Array.isArray(section.content) ? section.content : [section.content];
    
    return (
      <>
        {contentArray.map((paragraph, index) => (
          <p key={index} dangerouslySetInnerHTML={{ __html: paragraph }} />
        ))}
        {section.items && (
          <ul>
            {section.items.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        )}
      </>
    );
  };

  return (
    <div className="legal-page">
      <div className="legal-page__container">
        <h1 className="legal-page__title">{content.title}</h1>
        <div className="legal-page__content">
          <p className="legal-page__last-updated">{content.lastUpdated}</p>

          {content.sections.map((section, index) => (
            <section key={index} className="legal-page__section">
              {section.heading && (
                <h2 className="legal-page__heading">{section.heading}</h2>
              )}
              {section.subheading && (
                <h3 className="legal-page__subheading">{section.subheading}</h3>
              )}
              {renderContent(section)}
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;

